import { ShowSystemRequestSchema, ShowSystemResponseSchema } from './show-system.schema';
/**
 * Show System Endpoint Contract
 * Retrieves a specific system by ID
 */ export const showSystemContract = {
    method: 'GET',
    path: '/api/v2/system/:id',
    description: 'Retrieve a specific system by ID',
    requestSchema: ShowSystemRequestSchema,
    responseSchema: ShowSystemResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'System not found'
        }
    }
};

//# sourceMappingURL=show-system.contract.js.map